import { render, staticRenderFns } from "./ApplyCoupon.vue?vue&type=template&id=04b350bf&scoped=true"
import script from "./ApplyCoupon.vue?vue&type=script&lang=js"
export * from "./ApplyCoupon.vue?vue&type=script&lang=js"
import style0 from "./ApplyCoupon.vue?vue&type=style&index=0&id=04b350bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b350bf",
  null
  
)

export default component.exports